/** Revisions of one approval: each row is a press already made, opened as its pinned saved membership. */
import { inject, Injector } from '@angular/core';
import { ActivityEntityName, EntityViewDisplay, VisitApprovalRevisionRow } from '@jms/model';
import { registerManifest } from '@workbuddy/services/entities/entity.manifest.registry';
import type { EntityManifestBoardProfile } from '@workbuddy/services/entities/entity.manifest.surface';
import { EntityBoardContext, resolveBoardParams } from '@workbuddy/ui/v2/blocks/entity.board/context';
import { openApprovalRevision } from './commands/approval.open.revision.command';
import { ApprovalRevisionsBoardParams } from './visit.approval.detail.model';

/** A factory because row click needs the mount's approval and scope (`params`) and the board's injector. */
function approvalRevisionsBoard(page: EntityBoardContext): EntityManifestBoardProfile {

  const injector = inject(Injector);
  const params = resolveBoardParams<ApprovalRevisionsBoardParams>(page);
  return {
    supportedDisplays: [EntityViewDisplay.Table],
    restrictions: { supportedDisplays: [EntityViewDisplay.Table] },
    paging: 'keyset',
    params: { readonly: true },
    header: {
      // The registered server view, so the tab never inherits an unrelated `isDefault` view.
      defaultViewId: 'VisitApprovalRevision-history-embedded',
      showTitle: true,
      hideAdd: true,
      showSearch: false,
      showPaginator: true,
      showViewOptions: false,
      showBoardControls: false,
    },
    table: {
      fillerColumn: true,
      identifierLink: () => false,
      columns: {
        byField: {
          name: { minWidth: 190, flex: 1 },
          createdAt: { minWidth: 220 },
        },
      },
    },
    itemInteraction: {
      navigate: row => {
        if (params) void openApprovalRevision(injector, params, row);
      },
    },
  };
}

export const visitApprovalRevisionManifest = registerManifest<VisitApprovalRevisionRow>({
  entity: ActivityEntityName.VisitApprovalRevision,
  board: {
    base: approvalRevisionsBoard,
    profiles: {},
  },
});
